import React, { useEffect, useRef, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api, { checkAvailability } from 'services/api';
import { accessToStream } from 'services/api';
import Breadcrumbs from 'components/common/Breadcrumbs';
import ProgrammeSelector from 'components/common/ProgrammeSelector';
import PageCard from 'components/pages/PageCard'; // Nouvelle carte pour afficher les pages
import styles from './SpectacleDetailSummary.module.css';
import CardSpectacle from 'components/common/CardSpectacle';
import archiveStyle from 'styles/modules/Archives.module.css';
import { ReactComponent as SpectaclesIcon } from 'icons/spectacle.svg';
import { ReactComponent as ConcertIcon } from 'icons/concert.svg';
import Button from './Button';
import CartIcon from 'assets/icons/cart';
import CloseIcon from 'assets/icons/close';
import PlayIcon from 'assets/icons/play';
import { useCart } from 'contexts/CartContext';
import Spinner from 'components/common/Spinner';
import SpectacleDetailStream from './SpectacleDetailStream';

const mediaBaseUrl = process.env.REACT_APP_MEDIA_BASE_URL;

const SpectacleDetailSummary = ({ details, loading }) => {
  const [quantity, setQuantity] = useState({});
  const [totalTarif, setTotalTarif] = useState({});
  const [tarifQuantities, setTarifQuantities] = useState({});

  const [alert, setAlert] = useState(null);


  const [stopAddingQuantity, setStopAddingQuantity] = useState(false);

  const { addToCart, cartQuantityForEachDate, checkDisponibility } = useCart();

  const [selectedDate, changeSelectedDate] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => {
      window.requestAnimationFrame(() => {
        setIsMobile(window.innerWidth <= 991);
      });
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const newTotalTarif = {};
    Object.keys(tarifQuantities).forEach(dateId => {
      let total = 0;
      if (tarifQuantities[dateId] && details.categorieTarifaire) {
        Object.entries(tarifQuantities[dateId]).forEach(([tarifId, qty]) => {
          const tarif = details.categorieTarifaire.find(t => t.id === parseInt(tarifId, 10));
          if (tarif && tarif.tarifTTC) {
            total += qty * tarif.tarifTTC;
          }
        });
      }
      newTotalTarif[dateId] = total;
    });
    setTotalTarif(newTotalTarif);
  }, [tarifQuantities]);

  console.log('details', details);

  // Charger plus de pages
  //const loadMore = () => setDisplayCount((prevCount) => prevCount + 6);

  const onQuantityChange = ({ dateId, tarifId, action, streamable = false }) => {
    setAlert(null);
    if (action < 0 && (!tarifQuantities[dateId] || !tarifQuantities[dateId][tarifId])) {
      setAlert({
        type: "error",
        message: "Limite de places atteinte",
      });
      return;
    }

    if (streamable) {
      setQuantity(prev => ({ ...prev, [dateId]: (prev[dateId] ?? 0) + action }));
      setTarifQuantities(prev => ({
        ...prev,
        [dateId]: {
          ...prev[dateId],
          [tarifId]: prev[dateId] && prev[dateId][tarifId] ? prev[dateId][tarifId] + action : 1,
        },
      }));
      return;
    }

    if (((quantity[dateId] ?? 0) + action) > (details.configuration.nombrePlacePMR ?? 0) - (cartQuantityForEachDate[dateId] ?? 0)) {
      setAlert({
        type: "error",
        message: "Limite de places atteinte",
      });
      return;
    }
    /* if (!checkAvailability({ articleId: "articleId", quantity: (quantity[dateId] ?? 0) + action })) {
      return;
    } */

    setStopAddingQuantity(true);
    checkDisponibility({ dateId, quantity: (quantity[dateId] ?? 0) + action }).then((isAvailable) => {
      setStopAddingQuantity(false);
      console.log('isAvailable', isAvailable);

      if (isAvailable.success) {
        setQuantity(prev => ({ ...prev, [dateId]: (prev[dateId] ?? 0) + action }));
        setTarifQuantities(prev => ({
          ...prev,
          [dateId]: {
            ...prev[dateId],
            [tarifId]: prev[dateId] && prev[dateId][tarifId] ? prev[dateId][tarifId] + action : 1,
          },
        }));
      } else {
        setAlert({
          type: "error",
          message: "Limite de places atteinte",
        });
      }
    })

  }

  const handleAddToCart = async (cartItems) => {
    // Logique pour ajouter au panier
    let tokenPanier = null
    for (const item of cartItems) {
      const { dateId, tarifId } = item;
      console.log("Adding to cart:", item, "tokenPanier:", tokenPanier);
      const { tokenPanier: tp } = await addToCart({ dateId, tarifId, quantity: tarifQuantities[dateId][tarifId], slug: details.slug, tokenPanier, streamable: details.streamTarif && details.streamTarif.map(elm => String(elm.id)).includes(String(tarifId)) });
      tokenPanier = tp;
    }
  }

  const lieuRecapBilletterie = [details.lieu?.name, details.lieu?.city].filter(Boolean).join(', ');

  return (
    <>
      <div className={styles.spectacleDetailSummary}>
        {details.typeShow?.code === 'spectacle' && (
          <div className={styles.categoryBadge}>
            <SpectaclesIcon className={styles.categoryIcon} />
            <span>Spectacle</span>
          </div>
        )}
        {details.typeShow?.code === 'concert' && (
          <div className={`${styles.categoryBadge} ${styles.concertCategoryBadge}`}>
            <ConcertIcon className={styles.categoryIcon} />
            <span>Concert</span>
          </div>
        )}
        <h1 className={styles.title}>{details.name}</h1>
        {details.plage_date && (
          <p className={details.typeShow?.code === 'concert' ? `${styles.date} ${styles.concertDate}` : styles.date}>{details.plage_date}</p>
        )}

        {details.description && (
          <div
            className={styles.excerpt}
            dangerouslySetInnerHTML={{ __html: details.description }}
          />
        )}

        <div className={details.typeShow?.code === 'concert' ? `${styles.details} ${styles.concertDetails}` : styles.details}>
          <ul>
            {details.lieu && (
              <li>
                <span className={styles.field}>Lieu :</span>
                {details.lieu.address}
              </li>
            )}
            {details.duration && (
              <li>
                <span className={styles.field}>Durée :</span>
                {details.duration}
              </li>
            )}
            {details.spectacleGenre && details.spectacleGenre.length && (
              <li>
                <span className={styles.field}>Genre :</span>
                {details.spectacleGenre.map((genre) => (genre.name)).join(', ')}
              </li>
            )}
          </ul>
        </div>
        {isMobile && details.video &&
          <Link className='videoButton' to={details.video} data-fancybox="video" >
            <Button>
              <PlayIcon width={25} height={25} />
              Voir la bande annonce
            </Button>
          </Link>
        }
        {details.spectacleDate && details.spectacleDate.length > 0 && details.spectacleDate.some(date => date.streamable) &&
          <Link className='videoButton' to={`/programme/stream`} data-fancybox="video" >
            <Button>
              Regarder le live
            </Button>
          </Link>
        }
        <div className={styles.availableDates}>
          <h2 className={`${styles.availableDatesTitle} ${styles.sectionTitle}`}>Dates disponibles</h2>
          {alert && (
            <div className={`${styles.alert} ${styles[alert?.type]}`}>
              {alert?.message}
            </div>
          )}
          <ul className={styles.availableDatesList}>
            {details.spectacleDate && details.spectacleDate.map((item) => {
              console.log(item);

              // setQuantity(prev => ({ ...prev, [item.id]: 0 }));

              const isPastDate = new Date(item.date.date) < new Date() || item.dispos.availablePlacesForFront === 0 || details.categorieTarifaire.filter(tarif => tarif.tarifTTC !== 0).length === 0;

              const dateText = new Date(item.date.date).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
              });
              const dateTime = new Date(item.date.date).toLocaleTimeString('fr-FR', {
                hour: '2-digit',
                minute: '2-digit',
              });



              if (cartQuantityForEachDate[item.id] && cartQuantityForEachDate[item.id] >= details.configuration.nombrePlacePMR) {
                return (
                  <></>);
              }

              return (
                <li key={item.id} id={item.id} className={isPastDate ? styles.commandItemDisabled : ""}>
                  <div className={styles.commandItem}>
                    <div className={`${styles.commandItemAppearance} ${styles.commandItemDate}`}>
                      <div>
                        <div className={styles.dateTitle}>{dateText} à {dateTime}</div>
                        {lieuRecapBilletterie && (
                          <p className={styles.dateValue}>{lieuRecapBilletterie}</p>
                        )}
                      </div>
                      <Button variant={isPastDate ? 'white' : details.typeShow?.code === 'concert' ? 'secondary' : 'primary'} disabled={isPastDate} onClick={() => {
                        if (isPastDate) return;
                        changeSelectedDate(prev => {
                          if (prev === item.id) {
                            return null;
                          }
                          return item.id
                        });
                      }}>{isPastDate ? "Complet" : "Commander"}</Button>
                    </div>
                    {selectedDate === item.id && <>
                      <div className={styles.commandItemTarifs}>


                        {details.categorieTarifaire && details.categorieTarifaire.filter(tarif => tarif.tarifTTC !== 0).map(
                          (tarif) => {
                            // const isDisabled = quantity.find(q => q.tarifId === tarif.id)?.quantity === 0;
                            const tarifQuantity = tarifQuantities[item.id] && tarifQuantities[item.id][tarif.id] ? tarifQuantities[item.id][tarif.id] : 0;
                            return (
                              <div
                                key={tarif.id}
                                className={`${styles.commandItemAppearance} ${styles.commandItemAction}`}
                              >
                                <div className={styles.Tarif}>{tarif.name}
                                  {tarif.help && tarif.help !== "" &&
                                    <>
                                      <br />
                                      <span className={styles.TarifHint}>{tarif.help}</span>
                                    </>
                                  }
                                </div>
                                <div className={styles.TarifPrice}><span className={styles.commandItemPrice}>{tarif.tarifTTC.toFixed(2).replace('.', ',')} €</span> / Place</div>
                                <div className={styles.commandItemQuantity}>
                                  <label>Quantité :</label>{' '}
                                  <div>
                                    <input
                                      value={tarifQuantity}
                                      type="number"
                                      name="quantity"
                                      min={0}
                                      max={details.configuration.nombrePlacePMR - (cartQuantityForEachDate[item.id] ?? 0)}
                                      readOnly
                                    />
                                    <span
                                      className={styles.commandItemQuantityPlus}
                                      onClick={() => {
                                        if (!stopAddingQuantity) { onQuantityChange({ dateId: item.id, tarifId: tarif.id, action: 1 }); }
                                      }}
                                    ></span>
                                    <span
                                      className={styles.commandItemQuantityMinus}
                                      onClick={() => {
                                        if (!stopAddingQuantity) { onQuantityChange({ dateId: item.id, tarifId: tarif.id, action: -1 }); }
                                      }}
                                    ></span>
                                  </div>
                                </div>
                              </div>
                            )
                          }

                        )}
                        {item.streamable && details.streamTarif && details.streamTarif.filter(tarif => tarif.tarifTTC !== 0).map(
                          (tarif) => {
                            // const isDisabled = quantity.find(q => q.tarifId === tarif.id)?.quantity === 0;
                            const tarifQuantity = tarifQuantities[item.id] && tarifQuantities[item.id][tarif.id] ? tarifQuantities[item.id][tarif.id] : 0;
                            return (
                              <div
                                key={tarif.id}
                                className={`${styles.commandItemAppearance} ${styles.commandItemAction}`}
                              >
                                <div className={styles.Tarif}>{tarif.name}
                                  {tarif.help && tarif.help !== "" &&
                                    <>
                                      <br />
                                      <span className={styles.TarifHint}>{tarif.help}</span>
                                    </>
                                  }
                                </div>
                                <div className={styles.TarifPrice}><span className={styles.commandItemPrice}>{parseFloat(String(tarif.tarifTTC)).toFixed(2).replace('.', ',')} €</span> / Place</div>
                                <div className={styles.commandItemQuantity}>
                                  <label>Quantité :</label>{' '}
                                  <div>
                                    <input
                                      value={tarifQuantity}
                                      type="number"
                                      name="quantity"
                                      min={0}
                                      max={details.configuration.nombrePlacePMR - (cartQuantityForEachDate[item.id] ?? 0)}
                                      readOnly
                                    />
                                    <span
                                      className={styles.commandItemQuantityPlus}
                                      onClick={() => { onQuantityChange({ dateId: item.id, tarifId: tarif.id, action: 1, streamable: true }); }}
                                    ></span>
                                    <span
                                      className={styles.commandItemQuantityMinus}
                                      onClick={() => { onQuantityChange({ dateId: item.id, tarifId: tarif.id, action: -1, streamable: true }); }}
                                    ></span>
                                  </div>
                                </div>
                              </div>
                            )
                          }

                        )}
                      </div>
                      {!!totalTarif[item.id] && <div className={`${styles.commandItemAppearance} ${styles.commandItemTotal} ${details.typeShow?.code === 'concert' ? styles.concertCommandItemTotal : ''}`}>
                        <div>Total pour ce tarif :</div>
                        <div className={styles.commandItemPrice}>{totalTarif[item.id]?.toFixed(2)} €</div>
                      </div>}
                      <div className={styles.commandItemGroupButtons}>
                        <Button variant='white' onClick={() => {
                          changeSelectedDate(null)
                          setTarifQuantities((prev) => ({
                            ...prev,
                            [item.id]: {},
                          }));
                          setQuantity(prev => ({ ...prev, [item.id]: 0 }));
                        }}><CloseIcon />Annuler</Button>
                        <Button
                          variant={details.typeShow?.code === 'concert' ? 'secondary' : 'primary'}
                          onClick={() => {
                            const tempCartItems = [];
                            if (!tarifQuantities[item.id] || Object.keys(tarifQuantities[item.id]).length === 0) {
                              setAlert({ type: "error", message: "Veuillez sélectionner au moins un tarif." });
                              return;
                            }
                            Object.keys(tarifQuantities[item.id]).forEach((tarifId) => {
                              if (tarifQuantities[item.id][tarifId] === 0) {
                                delete tarifQuantities[item.id][tarifId];
                              } else {
                                tempCartItems.push({
                                  dateId: item.id,
                                  tarifId: tarifId,
                                  quantite: tarifQuantities[item.id][tarifId],
                                  slug: details.slug
                                });
                              }
                            });
                            if (tempCartItems.length === 0) {
                              setAlert({ type: "error", message: "Veuillez sélectionner au moins un tarif." });
                              return;
                            }
                            handleAddToCart(tempCartItems);
                            setTarifQuantities((prev) => ({
                              ...prev,
                              [item.id]: {},
                            }));
                            setQuantity(prev => ({ ...prev, [item.id]: 0 }));
                            setAlert({ type: "success", message: "Les articles ont été ajoutés au panier." });
                            changeSelectedDate(null);
                          }}
                        ><CartIcon />Ajouter au panier</Button>
                      </div>
                    </>}
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </div >
    </>
  );
};

export default SpectacleDetailSummary;
